/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Código',
    COUNTERPARTS: 'Contrapartidas',
    CURRENT: 'Corrente',
    GENERAL_INFORMATION: 'Informação geral',
    MANAGER: 'Gestor',
    PREVIOUS: 'Anterior',
    PRODUCTS: 'Produtos',
    REMUNERATION: 'Remunerações',
    SUPERVISOR: 'Supervisor'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
